jQuery(document).ready(function(){
    jQuery('.wp-block-buttons.is-style-anchor a[href^="#"]').click(function(e){
        const current = jQuery(e.target)
        const target = jQuery(`${current.attr('href')}`);

        if(target.length){
            jQuery('html, body').animate({
                scrollTop: target.offset().top - jQuery('header').outerHeight()
            }, 300);
        }
        setTimeout(setCurrentAnchorActive, 100);
    })
    setCurrentAnchorActive();
})

function setCurrentAnchorActive(){
    const currentAnchor = jQuery(location).attr('hash');
    jQuery(`a[href="${currentAnchor}"]`).addClass('active');
    jQuery(`a:not([href="${currentAnchor}"])`).removeClass('active');

    jQuery('.wp-block-buttons.is-style-anchor').each(function(){
        let currentButtons = jQuery(this);
        if(!currentButtons.find('> .wp-block-button > .wp-block-button__link.active').length) currentButtons.find('> .wp-block-button:first-child > .wp-block-button__link').addClass('active');
    })
}